import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=e9ad8f72&scoped=true&"
import script from "./JobItem.vue?vue&type=script&lang=js&"
export * from "./JobItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ad8f72",
  null
  
)

export default component.exports